
import Vue from 'vue';
import { Label } from './styles';

export default Vue.extend({
  name: 'CheckBoxRound',
  components: {
    Label,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Label',
    },
    name: {
      type: String,
      default: '',
    },
    value: [String, Boolean, Array],
    inputValue: [String, Boolean, Array],
  },
  computed: {
    model: {
      get(): any { return this.value; },
      set(value: any): void { this.$emit('input', value); },
    },
  },
});
